/** @jsx h */
import { Component, h } from 'preact'

export default Wrapped => {
  class TransitionIn extends Component {
    constructor (props) {
      super(props)
      this.state = {
        firstRender: true
      }
    }

    componentDidMount () {
      setTimeout(() => {
        this.setState({ firstRender: false })
      }, 0)
    }

    render () {
      return (
        <Wrapped
          {...Object.assign(
            { firstRender: this.state.firstRender },
            this.props
          )}
        />
      )
    }
  }

  return TransitionIn
}
